import Discount from "./discount";

export default Discount;
